import React from 'react';
import InputMask from 'react-input-mask-ts';

interface MaskedPhoneInputProps {
  field: any;
  form: any;
}

const MaskedPhoneInput = ({ field, form, ...props }: MaskedPhoneInputProps) => {
  const digits = (field.value || '').replace(/\D/g, '');
  const isMobile = digits.length > 2 && digits[2] === '9';
  const mask = isMobile ? '(99) 9 9999-9999' : '(99) 9999-9999';

  return (
    <InputMask
      mask={mask}
      value={field.value}
      onChange={field.onChange}
      onBlur={field.onBlur}
      name={field.name}
      {...props}></InputMask>
  );
};

export default MaskedPhoneInput;
